import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {AssetPref} from '../constants';

export const checksumEnabled = () =>
	getPreference(AssetPref.CHECKSUM_ENABLED, true);

export default checksumEnabled;
